export const RESTRICTED_PLACES_VIEW_PATH = '/places-restricted';
export const RESTRICTED_FREAKS_VIEW_PATH = '/freaks-restricted';
export const REGISTER = '/register';
